import { render, staticRenderFns } from "./ElementChoiceInputConfig.vue?vue&type=template&id=58de88d7&"
import script from "./ElementChoiceInputConfig.vue?vue&type=script&lang=js&"
export * from "./ElementChoiceInputConfig.vue?vue&type=script&lang=js&"
import style0 from "./ElementChoiceInputConfig.vue?vue&type=style&index=0&id=58de88d7&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58de88d7')) {
      api.createRecord('58de88d7', component.options)
    } else {
      api.reload('58de88d7', component.options)
    }
    module.hot.accept("./ElementChoiceInputConfig.vue?vue&type=template&id=58de88d7&", function () {
      api.rerender('58de88d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/ElementChoiceInputConfig.vue"
export default component.exports